export const statuses = [
    { value: 'new', displayValue: "New" },
    { value: 'scheduled', displayValue: "Scheduled" },
    { value: 'in_warehouse', displayValue: "In Warehouse" },
    { value: 'on_hold', displayValue: "On Hold" },
    { value: 'finished', displayValue: "Finished" },
];
export const types = [{ value: 'pickup', displayValue: 'Pickup' }, { value: 'delivery', displayValue: 'Delivery' }]